export default {
  data() {
    return {
      hideMouse: true
    };
  },
  watch: {
    $route() {
      document.querySelector('*').style.cursor = 'default';
      clearTimeout(this.mouseTimeout);
    }
  },
  methods: {
    cursorHandler() {
      //   console.log(event);
      // this.hideMouse = false;
      // console.log('show cursor');
      // this.$store.commit('setHideMouse', false);
      document.querySelector('*').style.cursor = 'default';
      if (this.mouseTimeout) {
        clearTimeout(this.mouseTimeout);
      }
      this.mouseTimeout = setTimeout(() => {
        // this.hideMouse = true;
        // console.log('hide cursor');
        document.querySelector('*').style.cursor = 'none';
        // this.$store.commit('setHideMouse', true);
      }, 3000);
    }
  }
};
